import { BFF_BASE_URL } from "../config/constants";
import axiosInstance from "../config/axiosIntance";

export type DeleteDeviceParams = {
  username: string;
  ciamId: string;
  deviceId: string;
  serviceProvider: string;
  token: string;
};

export const deleteDeviceService = async ({
  ciamId,
  deviceId,
  username,
  serviceProvider,
  token
}: DeleteDeviceParams): Promise<any> => {
  const dataFetched = await axiosInstance.delete<any>(
    `${BFF_BASE_URL}/ciam-tools-bff/devices/${ciamId}/devices/${deviceId}`,
    {
      headers: {
        serviceProvider: serviceProvider,
        username: username,
        Authorization: `Bearer ${token}`
      }
    }
  );

  return dataFetched.data;
};
